var render = function render(){
  var _vm$content, _vm$content$perfil;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(" Solicitações de Acesso – Visualizar Parecer ")])]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-subheader', {
    staticClass: "ml-0 mt-3",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Dados Pessoais")])]), _c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "nome",
      "label": "Nome",
      "outlined": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "id": "cpf",
      "label": "CPF",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "disabled": ""
    },
    model: {
      value: _vm.content.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.content, "cpf", $$v);
      },
      expression: "content.cpf"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "email",
      "label": "E-mail",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": ""
    },
    model: {
      value: _vm.content.email,
      callback: function ($$v) {
        _vm.$set(_vm.content, "email", $$v);
      },
      expression: "content.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '(##) #####-####',
      expression: "'(##) #####-####'"
    }],
    attrs: {
      "id": "telefone",
      "label": "Telefone para contato",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": ""
    },
    model: {
      value: _vm.content.telefone,
      callback: function ($$v) {
        _vm.$set(_vm.content, "telefone", $$v);
      },
      expression: "content.telefone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.content.possuiNomeSocial ? '6' : '12'
    }
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Possui nome social?")]), _c('v-radio-group', {
    staticClass: "ml-4",
    attrs: {
      "row": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.possuiNomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.content, "possuiNomeSocial", $$v);
      },
      expression: "content.possuiNomeSocial"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm.content.possuiNomeSocial ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "outlined": "",
      "dense": "",
      "maxlength": "100",
      "counter": "100",
      "disabled": ""
    },
    model: {
      value: _vm.content.nomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeSocial", $$v);
      },
      expression: "content.nomeSocial"
    }
  })], 1) : _vm._e()], 1), _c('v-subheader', {
    staticClass: "ml-0 mt-5",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Formação Profissional")])]), _c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "grauEscolaridade",
      "label": "Grau de Escolaridade",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.escolaridade,
      callback: function ($$v) {
        _vm.$set(_vm.content, "escolaridade", $$v);
      },
      expression: "content.escolaridade"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "localLotacao",
      "label": "Local de Lotação",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.lotacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "lotacao", $$v);
      },
      expression: "content.lotacao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "funcaoPrograma",
      "label": "Função no Programa",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.funcao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcao", $$v);
      },
      expression: "content.funcao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "municipio",
      "label": "Município",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "municipio", $$v);
      },
      expression: "content.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": _vm.content.possuiLotacaoDois ? '6' : '12'
    }
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v("Possui outro local de lotação?")]), _c('v-radio-group', {
    staticClass: "ml-4",
    attrs: {
      "row": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.possuiLotacaoDois,
      callback: function ($$v) {
        _vm.$set(_vm.content, "possuiLotacaoDois", $$v);
      },
      expression: "content.possuiLotacaoDois"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm.content.possuiLotacaoDois ? _c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.municipioDois,
      "label": "Município",
      "outlined": "",
      "dense": "",
      "disabled": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.lotacaoDois,
      "label": "Local de Lotação",
      "outlined": "",
      "dense": "",
      "disabled": ""
    }
  })], 1)], 1) : _vm._e(), _c('v-subheader', {
    staticClass: "ml-0 mt-5",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Parecer")])]), _c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Situação*",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.situacao.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content.situacao, "descricao", $$v);
      },
      expression: "content.situacao.descricao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [(_vm$content = _vm.content) !== null && _vm$content !== void 0 && (_vm$content$perfil = _vm$content.perfil) !== null && _vm$content$perfil !== void 0 && _vm$content$perfil.descricao ? _c('v-text-field', {
    attrs: {
      "id": "perfilAcesso",
      "label": "Perfil de acesso*",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.perfil.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content.perfil, "descricao", $$v);
      },
      expression: "content.perfil.descricao"
    }
  }) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "justificativa",
      "label": "Justificativa*",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "disabled": ""
    },
    model: {
      value: _vm.content.justificativa,
      callback: function ($$v) {
        _vm.$set(_vm.content, "justificativa", $$v);
      },
      expression: "content.justificativa"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }